module.exports = __webpack_public_path__ + "static/tigerwines-md-ea40bdef4dd9a205b4c143bf1404038d.jpg";